import React from "react";
import InspectionDetailsView from "./inspectionDetailsView";
import {
  setDoneInspectingCurrentQuestion,
  setImageCapturingMode,
  setReadyToSubmitReport,
  resetInspectionCaptureState,
} from "src/store/inspectionCaptureSlice";
import { resetInspectionResults } from "src/store/inspectionResultsSlice";
import {
  getInspectionsByUser,
  updateInspection,
  resetInspectionState,
} from "src/store/inspectionSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { useNavigate } from "react-router-dom";
import { completedInspectionStatus } from "src/constants/constants";

const SubmitReport = () => {
  const { selectedInspectionTemplate } = useAppSelector(
    (state) => state.inspectionTemplate
  );
  const { inspectionResults } = useAppSelector(
    (state) => state.inspectionResults
  );
  const { currentCreatedInspection } = useAppSelector(
    (state) => state.inspection
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleBack = () => {
    dispatch(setReadyToSubmitReport(false));
    navigate(`/templates/${selectedInspectionTemplate?.templateId}`);
  };

  const handleSubmit = async () => {
    if (!selectedInspectionTemplate) return;
    try {
      // Results are already saved incrementally during the inspection.
      // Just update the inspection status to "completed"
      await dispatch(
        updateInspection({
          inspectionId: currentCreatedInspection.inspectionId,
          templateId: currentCreatedInspection.templateId,
          templateName: currentCreatedInspection.templateName,
          siteCode: currentCreatedInspection.siteCode,
          status: completedInspectionStatus,
          createdBy: currentCreatedInspection.createdBy,
          createdAt: currentCreatedInspection.createdAt,
        })
      );

      // Reset state after successful submission
      dispatch(resetInspectionResults());
      dispatch(resetInspectionCaptureState());
      dispatch(resetInspectionState());

      dispatch(getInspectionsByUser());
      navigate("/home");
    } catch (error) {
      console.error("Failed to submit inspection:", error);
      // Optionally show error to user
    }
  };

  return (
    <InspectionDetailsView
      mode="review"
      templateName={selectedInspectionTemplate?.templateName}
      inspectionResults={inspectionResults}
      questions={selectedInspectionTemplate?.questions}
      inspectionId={currentCreatedInspection.inspectionId}
      onBack={handleBack}
      onSubmit={handleSubmit}
      showProgressBreadcrumb={true}
      currentStep={1}
    />
  );
};

export default SubmitReport;
